import * as CsvAnalysis from './CsvAnalysis';
import * as FeatureFlag from './FeatureFlag';
import * as ImportTableDefinition from './ImportTableDefinition';
import * as ImportTask from './ImportTask';
import * as SourceSystem from './SourceSystem';

export const apiConverter = {
  CsvAnalysis,
  FeatureFlag,
  ImportTableDefinition,
  ImportTask,
  SourceSystem,
};
